import Vue from "vue";
import Router from "vue-router";
import Index from "@views/home/Index";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import Loading from "@views/Loading";
import User from "@views/user/User";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "校园收费通",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: Index
    },
    {
      path: "/firstPage",
      name: "FirstPage",
      meta: {
        title: "校园收费通",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/home/FirstPage.vue")
    },
    {
      path: "/protocol",
      name: "protocol",
      meta: {
        title: "软件使用协议",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/home/Xieyi.vue")
    },
    {
      path: "/user",
      name: "User",
      meta: {
        title: "个人中心",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff"
      },
      component: User
    },
    {
      path: "/about",
      name: "SYAbout",
      meta: {
        title: "立数教育",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/SYAbout.vue")
    },
    {
      path: "/codeList",
      name: "CodeList",
      meta: {
        title: "二维码列表",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/user/CodeListView.vue")
    },
    {
      path: "/buyListViewDetail",
      name: "BuyListViewDetail",
      meta: {
        title: "商品购买记录",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/user/BuyListViewDetail.vue")
    },
    {
      path: "/buyProductList",
      name: "ProductList",
      meta: {
        title: "推荐商品列表",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/user/BuyListView.vue")
    },
    {
      path: "/user/binding",
      name: "BindingPhone",
      meta: {
        title: "绑定手机",
        keepAlive: false,
        backgroundColor: "#fff",
        auth: true
      },
      component: () => import("@views/user/BindingPhone.vue")
    },
    {
      path: "/user/cancelBinding",
      name: "CancelBindingPhone",
      meta: {
        title: "取消手机绑定",
        keepAlive: false,
        backgroundColor: "#fff",
        auth: true
      },
      component: () => import("@views/user/CancelBindingPhone.vue")
    },
    {
      path: "/tradeDetail/:id",
      name: "TradeDetail",
      meta: {
        title: "商品详情",
        keepAlive: false
      },
      component: () => import("@views/shop/SYTradeDetail.vue")
    },
    {
      path: "/codeDetail/:productId",
      name: "CodeDetail",
      meta: {
        title: "二维码详情",
        keepAlive: true
      },
      component: () => import("@views/shop/SYCodeDetail.vue")
    },
    {
      path: "/codeDetailUser/:productId",
      name: "CodeDetailUser",
      meta: {
        title: "二维码详情",
        keepAlive: true
      },
      component: () => import("@views/shop/SYCodeUserDetail.vue")
    },
    {
      path: "/buyDetail",
      name: "BuyDetail",
      meta: {
        title: "商品购买",
        keepAlive: true
      },
      component: () => import("@views/shop/SYBuyDetail.vue")
    },
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  // console.log('beforeEach');
  const { title, backgroundColor, footer, home, auth } = to.meta;
  console.log(to.name, form.name);
  // if (auth === true && !$store.state.app.token) {
  //   if (form.name === "Login") return;
  //   return toLogin(true, to.fullPath);
  // }
  if (form.name === "BindingPhone" && to.name !== "Index") {
    router.replace({ path: "/" });
    return;
  }

  document.title = title || process.env.VUE_APP_NAME || "";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  // console.log('beforeEach--1');
  if (auth) {
    // console.log('beforeEach--2');
    // $store.dispatch("USERINFO").then(() => {
      next();
    // });
  } else next();
});

export default router;
